import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";

const ArtworkMetaDesc = ({ artworkData }) => {
  const { pathname: url } = useLocation();

  const {
    slug,
    artwork_about: {
      artwork_title: title,
      artwork_medium: medium = "",
      artwork_price: price,
      artwork_currency: currency,
      artwork_color: colors = [],
      artwork_theme: themes = [],
      artwork_feeling: feelings = [],
      artwork_color: color=[],
      artwork_gallery: {
        user_name: galleryName,
        user_username: galleryUrl,
      } = {}, // Default to an empty object if artwork_gallery is undefined
      artwork_size: {
        unit = "cm",
        height = 50,
        length: width
      } = {},
      artwork_gallery_artist: {
        artist_name: artistName = "Unknown Artist" // Default value if artist_name is undefined
      } = {},
    } = {}, // Default to an empty object if artwork_about is undefined
    artwork_shipping: {
      artwork_shipping_own: {
        price: shippingNationalPrice
      } = {},
      artwork_shipping_rest: {
        price: shippingWorldPrice
      } = {}
    } = {}, // Default if artwork_shipping is undefined
    artwork_media: {
      artwork_main_picture: {
        image_url: imageUrl
      } = {}
    } = {},
    artwork_status: artworkStatus,
  } = artworkData || {}; // Default to an empty object if artworkData is undefined

  const helmetTitle = `${title} by ${artistName}`;
  const metaDescSuarteWorld="Get immersed in the art world. Scroll and interact with paintings and wall sculptures and find your next masterpiece. Join the conversation with likes, thoughts, ratings, and more. ";
  const metaDescriptionArtwork = `Discover ${title} by ${artistName} on Suarte. A ${height}${unit} x ${width}${unit}, ${medium}, ${themes.join(",")} that evokes ${feelings.join(",")},${color.join(",")}`;

  const unitCode = unit==="cm" ? "CMT" : "INH";

  const schema = {
    "@context": "http://schema.org",
    "@type": ["Product","CreativeWork"],
    "name": title,
    "description": metaDescriptionArtwork,
    "image": `${imageUrl}w=1366`,
    "url": `https://suarte.art${url}`,
    "brand": {
      "@type": "Brand",
      "name": "Suarte",
      "sameAs": "https://suarte.art"
    },
    "author": {
      "@type": "Person",
      "name": artistName,
    },
    "height": {
      "@type": "QuantitativeValue",
      "value": parseFloat(height) ,
      "unitCode": unitCode 
    },
    "width": {
      "@type": "QuantitativeValue",
      "value": parseFloat(width) ,
      "unitCode": unitCode 
    },
    "category": themes.join(', '),
    "color": colors.join(','),
    "material": medium,
    "offers": {
      "@type": "Offer",
      "price": price,
      "priceCurrency": currency,
      "itemCondition": "http://schema.org/NewCondition",
      "availability": artworkStatus === 'available' ? "http://schema.org/InStock" : "http://schema.org/OutOfStock",
      "seller": {
        "@type": "Organization",
        "name": galleryName,
        "sameAs": `https://suarte.art/user/${galleryUrl}`
      }, "shippingDetails": {
        "@type": "OfferShippingDetails",
        "shippingRate": [
          {
            "@type": "MonetaryAmount",
            "name": "National Shipping",
            "value": shippingNationalPrice || 0 ,
            "currency": currency
          },
          {
            "@type": "MonetaryAmount",
            "name": "Rest of the world",
            "value": shippingWorldPrice || 0,
            "currency": currency
          }
        ]
      }
    },
  };
  
  // Check if the last element of the arrayUrl matches the slug by comparing them.
  const artworkDataMachesURL = url.endsWith(slug);
  
  // If the url contains suarteworld, then the meta description is different.
  const metaDescription = url?.includes("suarteworld") ? metaDescSuarteWorld : metaDescriptionArtwork;
  const canonical = url?.includes("suarteworld") ? "/suarteworld" : "";
  return (
    <>
      {/* I have to find out if the id of the artowk mahes with the url */}
      { artworkDataMachesURL &&   
      <Helmet>
        <title>{helmetTitle}</title>
        <meta name="description" content={metaDescription} />
        <link rel="canonical" href={`https://suarte.art${canonical}/artwork/${artworkData.slug}`} />
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      </Helmet>
      }
      
    </>

  );
};

export default ArtworkMetaDesc;